/**
 * Product Sales Report Factory
 *
 * Factory pattern for dependency injection in Product Sales Report feature
 */

import {ProductSalesReportAPIDataSourceImpl} from '../api/ProductSalesReportAPIDataSource';
import {ProductSalesReportRepositoryImpl} from '../repository/ProductSalesReportRepositoryImpl';
import {GetProductSalesReportUseCase} from '../useCases/GetProductSalesReportUseCase';

export class ProductSalesReportFactory {
  private static apiDataSource: ProductSalesReportAPIDataSourceImpl;
  private static repository: ProductSalesReportRepositoryImpl;
  private static getProductSalesReportUseCase: GetProductSalesReportUseCase;

  static getAPIDataSource(): ProductSalesReportAPIDataSourceImpl {
    if (!this.apiDataSource) {
      this.apiDataSource = new ProductSalesReportAPIDataSourceImpl();
    }
    return this.apiDataSource;
  }

  static getRepository(): ProductSalesReportRepositoryImpl {
    if (!this.repository) {
      this.repository = new ProductSalesReportRepositoryImpl(this.getAPIDataSource());
    }
    return this.repository;
  }

  static getGetProductSalesReportUseCase(): GetProductSalesReportUseCase {
    if (!this.getProductSalesReportUseCase) {
      this.getProductSalesReportUseCase = new GetProductSalesReportUseCase(this.getRepository());
    }
    return this.getProductSalesReportUseCase;
  }
}

